import {ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {Accordion} from "@mantine/core";
import {RenderableDocument, DibJsonNode} from "../types";
import classes from "./XboxLEGACY.module.css";

type Props = {
    node: DibJsonNode;
    children: ReactNode[];
    map: RenderableDocument;
};

export const XboxLEGACY = ({node, children, map}: Props) => {
    const {t} = useTranslation();
    const attrs = node.element?.attributes;
    const id = attrs?.id ?? "xbox";

    const firstChildRef = node.element?.children?.[0];
    const firstChildId =
        firstChildRef && "id" in firstChildRef ? firstChildRef.id : null;
    const hasCaption =
        firstChildId !== null &&
        map.elements[firstChildId]?.name === "figcaption";

    const title = hasCaption ? children[0] : null;
    const body = hasCaption ? children.slice(1) : children;

    const defaultOpen = attrs?.["data-defaultopen"] === "open";

    return (
        <Accordion
            variant="contained"
            radius={7.5}
            defaultValue={defaultOpen ? id : undefined}
            classNames={{
                root: classes.root,
                item: classes.item,
                control: classes.control,
                panel: classes.panel,
                content: classes.content,
            }}
        >
            <Accordion.Item value={id}>
                <Accordion.Control>
                    <div className={classes.controlInner}>
                        <span className={classes.title}>{title}</span>
                        <span className={classes.subtitleMore}>
                            {t("Label.ShowMore", {defaultValue: "Vis mer"})}
                        </span>
                        <span className={classes.subtitleLess}>
                            {t("Label.ShowLess", {defaultValue: "Vis mindre"})}
                        </span>
                    </div>
                </Accordion.Control>
                <Accordion.Panel>{body}</Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
};
